export default function Banner() {
	return (
		<div className="banner">
			Hello Haxball World :O
		</div>
	)
}
